import type { PaginationModel, SortModel } from '@/components'
import { typedEntries } from './typed-entries.ts'

type HasToString = {
  toString(): string
}

export function buildSearchParameters<T>(
  filters: Record<string, HasToString | HasToString[] | undefined>,
  options: {
    sorting?: SortModel<T>
    pagination?: PaginationModel
  }
): URLSearchParams {
  const searchParams = new URLSearchParams()

  typedEntries(filters)
    .filter(([, value]) => (Array.isArray(value) ? value.length : value != undefined))
    .forEach(([key, value]) => {
      searchParams.append(
        key,
        Array.isArray(value) ? value.map(it => it.toString()).join(',') : value.toString()
      )
    })

  if (options.sorting) {
    searchParams.append('sortBy', options.sorting.field.toString())
    searchParams.append('sortDirection', options.sorting.direction)
  }

  if (options.pagination) {
    searchParams.append('page', options.pagination.page.toString())
    searchParams.append('pageSize', options.pagination.pageSize.toString())
  }

  return searchParams
}
